/**
 * Created by slava on 4/3/20
 */

const CardView = cc.Node.extend({
    ctor: function (card, options) {
        this._super();

        this.card = card;
        this.options = options || {};

        this.setContentSize2(cleverapps.styles.CardView);
        this.setAnchorPoint(0.5, 0.5);

        this.addControls();
        this.createAnimation();
        this.addChild(this.animation, -1);
        this.setCascadeColorEnabled(true);
        this.setCascadeOpacityEnabledRecursively(true);

        if (card.x !== undefined) {
            this.setRotation(card.getRotation());
        }

        this.markViews = this.card.marks.map((mark) => {
            const markView = new MarkView(mark);
            markView.visible = false;
            markView.setLocalZOrder(10);
            this.addChild(markView);

            if (this.card.isOpen() || cleverapps.environment.isSceneWithPreview()) {
                markView.show(true);
            }
            return markView;
        });

        card.on("animateShowUp", this.screenShowUp.bind(this));
        card.on("hide", this.hide.bind(this));

        card.on("showTutorial", this.showTutorial.bind(this));
        card.on("hideTutorial", this.hideTutorial.bind(this));

        card.on("changeValue", this.onChangeValue.bind(this));

        card.on("flip", this.createListener(this.onFlip.bind(this)));
        card.on("wrongMove", this.wrongMove.bind(this));
        card.on("changeOwner", this.createListener(this.changeOwner.bind(this)));
        card.on("updateZ", () => {
            this.setLocalZOrder(card.getZ());
        });

        this.scale = this.card.getScale();

        card.onReturnToScreen = this.createListener(this.animateReturnToScreen.bind(this));
        card.on("moveToOpen", this.moveToOpen.bind(this));

        card.onGetView = this.createListener(() => this);

        cleverapps.focusManager.on("changeFocus", () => {
            this.hideTutorial();
        }, this);
    }
});

CardView.convertToViewPosition = function (p) {
    return {
        x: p.x * resolutionScale,
        y: p.y * resolutionScale
    };
};

CardView.createCardView = function (card) {
    const ViewClass = card.getViewClass();
    const cardView = new ViewClass(card);
    card.components.forEach((component) => {
        const ComponentViewClass = component.getViewClass();
        cardView.addChild(new ComponentViewClass(component));
    });

    return cardView;
};

CardView.prototype.changeOwner = function (owner) {
    const ownerView = owner.getView();
    this.replaceParentSamePlace(ownerView, {
        keepScale: true
    });

    if (owner instanceof TileTable) {
        if (this.moveToOpenAction && !this.moveToOpenAction.isDone()) {
            this.stopAction(this.moveToOpenAction);
            this.moveToOpenAction = undefined;
        }
        this.setLocalZOrder(this.card.getZ());
    } else if (owner instanceof OpenCards) {
        this.setLocalZOrder(owner.cards.length);
    } else {
        this.setLocalZOrder(0);
    }
};

CardView.prototype.addControls = function () {
    if (!cleverapps.environment.isAdministratorScene() && !cleverapps.environment.isEditorScene() && this.card.feature !== "streak") {
        if (this.onTouchHandler) {
            this.onTouchHandler.remove();
            this.onTouchHandler = undefined;
        }

        this.onTouchHandler = cleverapps.UI.onPressed(this, this.card.onClickListener.bind(this.card));
    }
};

CardView.prototype.wrongMove = function () {
    cleverapps.effects.fire("tile3.wrong");
    this.runAction(new cc.Sequence(
        new cc.DelayTime(0.2 * Math.random()),
        new cc.RotateBy(0.08, -20),
        new cc.RotateBy(0.08, 40).easing(cc.easeInOut(0.5)),
        new cc.RotateBy(0.08, -40).easing(cc.easeInOut(0.5)),
        new cc.RotateBy(0.08, 20),
        new cc.RotateTo(0, this.card.getRotation())
    ));
};

CardView.prototype.getShuffleFinishPosition = function () {
    return this.card.getViewPosition().point;
};

CardView.prototype.onFlip = function (silent) {
    if (silent) {
        this.setIdleAnimation();
    } else {
        this.animation.setAnimation(0, this.card.isOpen() ? "open" : "close", false);
        this.animation.setCompleteListener(() => {
            this.animation.setCompleteListener();
            this.setIdleAnimation();
        });
    }
};

CardView.prototype.moveToOpen = function (duration, fromTable) {
    if (this.explodeAction) {
        return;
    }
    const finalScale = cleverapps.styles.OpenCardsView.slotSize / cleverapps.styles.CardView.width;

    if (this.moveToOpenAction && !this.moveToOpenAction.isDone()) {
        duration = this.moveToOpenAction._duration - this.moveToOpenAction._elapsed;
        this.stopAction(this.moveToOpenAction);
    }

    const actions = [cleverapps.UI.animateCard({
        cardView: this,
        position: this.card.getViewPosition(),
        duration,
        scale: finalScale,
        path: fromTable,
        rotation: fromTable 
    })];

    actions.push(new cc.CallFunc(() => {
        this.setRotation(0);
    }));

    this.moveToOpenAction = this.runAction(new cc.Sequence(actions));
};

CardView.prototype.animateReturnToScreen = function (index) {
    const tableView = cleverapps.Scenes.GetSceneComponent(TileGameSceneComponent).cardTableView;
    const newScale = tableView.newScale || tableView.scale;

    const calcReturnPosition = function () {
        const position = this.card.getViewPosition();
        const newOffset = tableView.animateOffset || cc.p(0, 0);
        const scale = tableView.scale;
        const centerNodeOffset = tableView.centerNodeOffset;

        if (newScale !== tableView.scale) {
            position.point.y *= newScale / scale;
            position.point.x *= newScale / scale;
            position.point.y += ((centerNodeOffset.y * scale) - (centerNodeOffset.y * newScale)) / scale;
            position.point.x += ((centerNodeOffset.x * scale) - (centerNodeOffset.x * newScale)) / scale;
        }

        position.point.y += newOffset.y;
        position.point.x += newOffset.x;

        return position;
    }.bind(this);

    if (cleverapps.config.type === "tile3") {
        const starparticles = new cleverapps.Spine(bundles.card.jsons.starparticles_json);
        this.addChild(starparticles);
        starparticles.setLocalZOrder(-1);
        let animationName = "center";
        starparticles.setAlignment(this.width / 2, 0);
        const position = calcReturnPosition();
        if (position.point.x > this.x && Math.abs(position.point.x - this.x) > cleverapps.styles.CardView.directMoveDx) {
            animationName = "left";
        }
        if (position.point.x < this.x && Math.abs(this.x - position.point.x) > cleverapps.styles.CardView.directMoveDx) {
            animationName = "right";
        }
        starparticles.setAnimation(0, animationName, false);
        starparticles.setCompleteListenerRemove();
    }

    this.stopAllActions();
    this.runAction(
        new cc.Spawn(
            new cc.RotateTo(Card.RETURN_TIMEOUT, this.card.r),
            cleverapps.UI.animateCard({
                cardView: this,
                dynamicRatioOfParentScale: newScale / tableView.scale,
                position: calcReturnPosition,
                duration: Card.RETURN_TIMEOUT,
                midpoint: cleverapps.styles.CardView.moveMidpoint,
                delay: index ? index * 0.03 : false,
                test: true
            })
        )
    );
};

CardView.prototype.hide = function () {
    this.visible = false;
};

CardView.prototype.createAnimation = function () {
    this.animation = new cleverapps.Spine(this.options.animation_json || bundles.card.jsons.card_json);
    this.onChangeValue();
    this.setIdleAnimation();
    this.animation.setPosition(this.width / 2, this.height / 2);
    this.fitAnimationScale();
};

CardView.prototype.fitAnimationScale = function () {
    const scale = Card.WIDTH * resolutionScale / this.animation.width;
    this.animation.setScale(scale);
};

CardView.prototype.setIdleAnimation = function () {
    this.animation.setAnimation(0, this.card.isOpen() ? "idle_open" : "idle_close", true);
};

CardView.prototype.onChangeValue = function () {
    this.animation.setSkin(this.card.getSkin());
};

CardView.prototype.showTutorial = function () {
    this.finger = FingerView.hintTap(this, {
        delay: 10,
        repeatDelay: 10
    });

    if (!this.pointer) {
        const pointer = PointerView.create({
            target: this
        });
        pointer.setVisible(false);
        pointer.runAction(new cc.Sequence(
            new cc.DelayTime(5),
            new cc.Show()
        ));
        this.pointer = pointer;
    }
};

CardView.prototype.hideTutorial = function () {
    FingerView.remove(this.finger);
    PointerView.remove(this.pointer);
    this.pointer = undefined;
    this.finger = undefined;
};

CardView.prototype.screenShowUp = function (f, silent) {
    if (silent) {
        this.visible = true;
        f();
        return;
    }

    const scene = cleverapps.Scenes.GetRunningScene();
    const finalPosition = this.getPosition();
    const finalRotation = this.getRotation();
    const finalScale = this.getScale();
    const finalZOrder = this.getLocalZOrder();

    const cardOffset = this.height / Math.sin(cleverapps.styles.CardView.screenShowUp.rotation * Math.PI / 180);
    let position;

    if (cleverapps.resolution.mode === cleverapps.WideMode.HORIZONTAL) {
        position = cc.p(scene.width / 2, scene.height + cardOffset);
    } else {
        position = cc.p(-cardOffset, scene.height / 2);
    }

    this.setAlignment(this.parent.convertToNodeSpace(scene.convertToWorldSpace(position)));
    this.setRotation(finalPosition.x > 0 ? cleverapps.styles.CardView.screenShowUp.rotation : -cleverapps.styles.CardView.screenShowUp.rotation);
    this.setLocalZOrder(100);

    this.visible = true;
    this.runAction(
        new cc.Sequence(
            new cc.Spawn(
                new cc.Sequence(
                    new cc.DelayTime(0.3),
                    new cc.ScaleTo(0.3, finalScale * 1.2).easing(cc.easeIn(1))
                ),
                new cc.MoveTo(0.8, finalPosition).easing(cc.easeInOut(2)),
                new cc.RotateTo(0.8, finalRotation),
                new cc.Sequence(
                    new cc.DelayTime(0.6),
                    new cc.ScaleTo(0.4, finalScale).easing(cc.easeOut(1))
                )
            ),
            new cc.CallFunc(() => {
                this.setAlignment(finalPosition);
                this.setLocalZOrder(finalZOrder);
                f();
            })
        )
    );
};

CardView.prototype.animateLose = function (index) {
    let loseAnimation = undefined;
    if (this.card.isOpen()) {
        loseAnimation = index % 2 === 0 ? "lose_left_nominal" : "lose_right_nominal";
    } else {
        loseAnimation = index % 2 === 0 ? "lose_left_backside" : "lose_right_backside";
    }

    this.replaceParentSamePlace(cleverapps.Scenes.GetMovingNode(this), {
        keepScale: true
    });

    const timeScale = 0.8 + Math.random() * 0.9;
    this.animation.setTimeScale(timeScale);
    const animationTime = this.animation.getAnimationDuration(loseAnimation) / timeScale;

    const delayTime = 0.01 * index * timeScale;
    const flyTime = 2 / timeScale;
    const rotateTime = 0.1;
    const cardBox = this.getGlobalBoundingBox();
    const flyOnSceneTime = flyTime * ((cardBox.y + cardBox.height) / cleverapps.resolution.getBgSize().height);

    this.setCascadeOpacityEnabled(true);
    this.runAction(new cc.Sequence(
        new cc.DelayTime(delayTime),
        new cc.CallFunc(() => {
            this.animation.setAnimation(0, loseAnimation, false);
        }),
        new cc.Spawn(
            new cc.RotateTo(rotateTime, 0),
            new cc.MoveBy(flyTime, 0, -cleverapps.resolution.getBgSize().height).easing(cc.easeIn(4))
        ),
        new cc.RemoveSelf()
    ));

    this.runAction(new cc.Sequence(
        new cc.DelayTime(0.05 * index),
        cleverapps.effects.fireAction("tile3.card.play")
    ));

    return Math.max(delayTime + flyOnSceneTime, animationTime);
};

CardView.prototype.unlockSpawnAnimate = function (isFirst) {
    const styles = cleverapps.styles.TilesUnlockWindow;

    this.animation.setOpacity(0);
    this.icon.setOpacity(0);

    this.setScale(0.2);
    this.setAlignment(styles.animation);

    const offsetX = isFirst ? -styles.tiles.offset : styles.tiles.offset;

    return new cc.Sequence(
        new cc.DelayTime(isFirst ? 0.2 : 0.4),
        new cc.Spawn(
            new cc.ScaleTo(1.5, styles.tiles.scale),
            new cc.CallFunc(() => {
                this.animation.runAction(new cc.FadeIn(0.5));
                this.icon.runAction(new cc.FadeIn(0.5));
            }),
            new cc.RotateBy(1.5, isFirst ? -360 : 360),
            new cc.MoveBy(1.5, offsetX, 3 * styles.height / 5)
        ).easing(cc.easeElasticOut(1.2))
    );
};

CardView.prototype.unlockEndAnimate = function (callback, isFirst) {
    this.replaceParentSamePlace(cleverapps.Scenes.GetRunningScene());
    this.setLocalZOrder(WindowComponent.WINDOWS_ZORDER + 3);

    const angle = isFirst ? -200 : 200;
    this.runAction(new cc.Sequence(
        new cc.DelayTime(isFirst ? 0.2 : 0),
        new cc.Spawn(
            new cc.MoveBy(1.5, 0, cleverapps.resolution.getSceneSize().height).easing(cc.easeElasticIn(0.6)),
            new cc.RotateBy(1.5, angle).easing(cc.easeIn(5))
        ),
        new cc.CallFunc(callback),
        new cc.RemoveSelf()
    ));
};

cleverapps.styles.CardView = {
    width: 0,
    height: 0,

    moveMidpoint: {
        x: 50,
        y: 250
    },

    screenShowUp: {
        rotation: 30
    },

    showUpOffset: 0,
    shuffleRadius: 250,
    directMoveDx: 150,

    shine: {
        x: { align: "center" },
        y: { align: "center" }
    }
};

cleverapps.styles.CardView.width = Card.WIDTH;
cleverapps.styles.CardView.height = Card.HEIGHT;
